import { Button } from "antd";
import React from "react";
import { addHttpToLink } from "../../../../Utils/StayUpToDate/RenderComponent";
import { TwitterIcon } from "./SocialIconUtils";
import { isHexDark } from "../../../../Utils/HelperFunction/HelperFunction";
import { darkenColor, lightenColor } from "../../../../Screens/DashboardView/StayUpToDate/LandingPageComponents/LinksComponent/Components/hoverUtils";

const PostInfoExternalLink = (props: any) => {
  const {
    external_link,
    handleRedirect,
    post_id,
    media_url,
    platform,
    user_id,
    name,

    socialIconColor,
    designTokens
  } = props;

  const { templateName, secondaryColor, tertiaryColor, fontFamily, secondaryFontFamily, forthColor } = designTokens ?? {};
  const isDefaultTemplate = templateName === "Default";
  const buttonBackground = isDefaultTemplate ? "#000000" : secondaryColor;
  const buttonTextColor = isDefaultTemplate ? "#FFFFFF" : tertiaryColor;

  return (
    <>
      {/* Remove hover effect - keep button colors consistent across all states */}
      <style>{`
        /* Ensure AntD button keeps same styles across all states (no hover effect) */
        .shoppable-btn,
        .shoppable-btn:hover,
        .shoppable-btn:focus,
        .shoppable-btn:active,
        .ant-btn.shoppable-btn,
        .ant-btn.shoppable-btn:hover,
        .ant-btn.shoppable-btn:focus,
        .ant-btn.shoppable-btn:active,
        a .shoppable-btn,
        a .shoppable-btn:hover,
        a:hover .shoppable-btn {
          background-color: ${buttonBackground} !important;
          color: ${buttonTextColor} !important;
          border-color: transparent !important;
          box-shadow: none !important;
          text-shadow: none !important;
          opacity: 1 !important;
          transform: none !important;
          transition: none !important;
        }
      `}</style>
      {external_link ? (
        <a
          href={addHttpToLink(external_link)}
          target="_blank"
          rel="noreferrer"
          style={{
            display: "inline-flex",
            alignItems: "center",
            verticalAlign: "middle",
            lineHeight: "inherit",
            textDecoration: "none",
            outline: "none",
            border: "none",
            ...(secondaryFontFamily ? { fontFamily: secondaryFontFamily } : {}),
          }}
        >
          <Button
            className="shoppable-btn"
            style={{
              backgroundColor: buttonBackground,
              color: buttonTextColor,
              border: "none",
              ...(secondaryFontFamily ? { fontFamily: secondaryFontFamily } : {}),
              ...(forthColor && {["--hover-shop-btn-bg" as any]: isHexDark(forthColor) ? lightenColor(forthColor, 20) : darkenColor(forthColor, 10)}),
            }}
            onClick={() => {
              handleRedirect(post_id, media_url, platform, name, user_id);
            }}
          >
            View
          </Button>
        </a>
      ) : (
        ""
      )}
    </>
  );
};

export default PostInfoExternalLink;
